import { fetchAll, removeItem, newItem, editItem } from '@/services/profession.service';

import * as types from './mutation-types';

export default {
  async fetchList({ commit }) {
    commit(types.SET_ERRORS, null);
    try {
      const data = await fetchAll();
      commit(types.SET_LIST, data);
    } catch ({ message }) {
      commit(types.SET_ERRORS, true);
    }
  },

  async removeItem({ commit, dispatch }, id) {
    commit(types.SET_ERRORS, null);
    try {
      await removeItem(id);
      dispatch('fetchList');
    } catch ({ message }) {
      commit(types.SET_ERRORS, true);
    }
  },

  async addItem({ commit, dispatch }, data) {
    commit(types.SET_ERRORS, null);
    try {
      await newItem(data);
      dispatch('fetchList');
    } catch ({ message }) {
      commit(types.SET_ERRORS, true);
    }
  },

  async changeItemById({ commit, dispatch }, { id, data }) {
    commit(types.SET_ERRORS, null);
    try {
      await editItem(id, data);
      dispatch('fetchList');
    } catch ({ message }) {
      commit(types.SET_ERRORS, true);
    }
  }
};
